import "../style/calendar/Calendar.scss";
// import BigCalendar from './BigCalendar';
import BigCalendar2 from "./BigCalendar2";
import Events from "./Events";

const Calendar = () => {
  return (
    <div className="Calendar">
      <Events />
      {/* <BigCalendar/> */}
      <BigCalendar2 />
    </div>
  );
};

export default Calendar;
